import React, { useState } from 'react';
import { ButtonContainer, ButtonLabel } from './styles';
import CompleteTicketModal from './CompleteTicketModal';
import { COMPLETE_TICKET } from 'src/Utils/constants';
var CompleteTicketButton = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.showNotifyCheckbox, showNotifyCheckbox = _c === void 0 ? false : _c;
    var _d = useState(false), showConfirmation = _d[0], setShowConfirmation = _d[1];
    var handleButtonClick = function () {
        setShowConfirmation(true);
    };
    var handleConfirmComplete = function (notifyClient) {
        onClick(notifyClient);
        setShowConfirmation(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonContainer, { onClick: handleButtonClick, disabled: disabled, type: "button" },
            React.createElement(ButtonLabel, null, COMPLETE_TICKET)),
        React.createElement(CompleteTicketModal, { isOpen: showConfirmation, setIsOpen: setShowConfirmation, onConfirm: handleConfirmComplete, showNotifyCheckbox: showNotifyCheckbox })));
};
export default CompleteTicketButton;
